import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark text-light pt-4">
      <div className="container">
        <div className="row">
          {/* About Section */}
          <div className="col-md-4 mb-3">
            <h5>Jom Free Credit</h5>
            <p>
              Your trusted source for free credits, gaming offers, and slot
              updates in Malaysia. Stay updated daily!
            </p>
            <p>
              365 Hari Cuci slot Bonus | FreeCreditNoDeposit | New Register Free
              RM 50 | 365cuci 100cuci 711cuci
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <a as={Link} to="/" className="text-light text-decoration-none">
                  Home
                </a>
              </li>
              <li>
                <a as={Link} to="/" className="text-light text-decoration-none">
                  Free Credit List
                </a>
              </li>
              <li>
                <a
                  as={Link}
                  to="/aboutus"
                  className="text-light text-decoration-none"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-4 mb-3">
            <h5>Follow Us</h5>
            <div className="d-flex gap-3">
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-facebook"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-instagram"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-linkedin"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center py-3 border-top mt-3">
          &copy; {new Date().getFullYear()} Jom Free Credit. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
